module.exports = __webpack_public_path__ + "assets/img/chalice.0ff71b11.png";